import { useTranslations } from '@vocab/react';
import { Text, Strong, Box, Stack } from 'braid-design-system';

import type { WorkHistory } from '../../../types/profile.types';
import { generateFakeWorkHistories } from '../../../utils/generateFakeWorkHistories';
import translations from '../WorkHistory/.vocab';

import { workHistoryWrapperStyle } from './FakeWorkHistory.css';
import { workHistoryTextStyle } from '../WorkHistory/WorkHistory.css';

interface Props {
  realWorkHistory: WorkHistory;
}

export const FakeWorkHistory = ({ realWorkHistory }: Props) => {
  const fakeHistories: WorkHistory[] =
    generateFakeWorkHistories(realWorkHistory);

  const { t } = useTranslations(translations);

  const blurStyle = {
    filter: 'blur(4px)',
    padding: '0 4px',
  };

  return (
    <Box className={workHistoryWrapperStyle}>
      <Stack space="xsmall">
        {fakeHistories.map(({ duration, roleTitle, companyName }, index) => (
          <Box
            key={`${roleTitle}-${index}`}
            data={{ testid: 'work-history' }}
            className={workHistoryTextStyle}
            flexWrap="wrap"
            aria-hidden="true"
            data-nosnippet
          >
            <Text maxLines={1} size="small">
              <span
                style={{
                  whiteSpace: 'pre-wrap',
                  ...(index === 0 ? {} : blurStyle),
                }}
              >
                {t('JOB_AT_COMPANY', {
                  JobTitle: (_) => <Strong>{roleTitle}</Strong>,
                  CompanyName: (_) => <Strong>{companyName}</Strong>,
                })}{' '}
              </span>
            </Text>
            {Boolean(duration) && (
              <Text maxLines={1} size="small">
                <span style={blurStyle}>{duration}</span>
              </Text>
            )}
          </Box>
        ))}
      </Stack>
    </Box>
  );
};
